import React from "react";
import {
  Notice,
  NumberInput,
  Panel,
  SelectInput,
  TextInput,
  ToggleInput,
} from "../input";
import { isUpdatedFromDefault } from "../utils";
import { INPUT_LIMITS } from "../input-limits";

function Sticky({ block, actions, ...props }) {
  const {
    id,
    props: { sticky = {} },
    dom,
  } = block;

  const { setProp } = actions;

  return (
    <>
      <Panel
        isUpdated={isUpdatedFromDefault([{ key: sticky, default: {} }])}
        id={`block-setting-${id}-sticky`}
        title={"Sticky"}
        initialOpen={false}
      >
        <SelectInput
          isResetVisible={false}
          value={sticky?.mode}
          onChange={(val) => {
            setProp((props) => {
              props.sticky = {
                ...(props.sticky ? props.sticky : {}),
                mode: val,
              };
            });
          }}
          options={[
            {
              label: "None",
              value: "",
            },
            {
              label: "Top",
              value: "top",
            },
            {
              label: "Bottom",
              value: "bottom",
            },
          ]}
          label={"Sticky"}
        />
        {sticky?.mode && (
          <>
            <NumberInput
              isResetVisible={false}
              max={INPUT_LIMITS["sticky-support-offset"].max}
              min={INPUT_LIMITS["sticky-support-offset"].min}
              step={INPUT_LIMITS["sticky-support-offset"].step}
              value={sticky?.offset}
              onChange={(val) => {
                setProp((props) => {
                  props.sticky = {
                    ...(props.sticky ? props.sticky : {}),
                    offset: val,
                  };
                });
              }}
              label={"Offset"}
            />
            <ToggleInput
              isResetVisible={false}
              value={sticky?.keepInsideParent}
              onChange={(val) => {
                setProp((props) => {
                  props.sticky = {
                    ...(props.sticky ? props.sticky : {}),
                    keepInsideParent: val,
                  };
                });
              }}
              label={"Keep inside Parent"}
            />
            {sticky?.keepInsideParent && (
              <>
                <Notice
                  status="success"
                  text={`By default, the immediate parent container will be referenced. Use the 'CSS Selector' from below to target the custom closest parent.`}
                />
                <TextInput
                  minLength={INPUT_LIMITS["custom-classname"].minlength}
                  maxLength={INPUT_LIMITS["custom-classname"].maxlength}
                  isResetVisible={false}
                  value={sticky?.insideParent}
                  onChange={(val) => {
                    setProp((props) => {
                      props.sticky = {
                        ...(props.sticky ? props.sticky : {}),
                        insideParent: val,
                      };
                    });
                  }}
                  placeholder=".class-name"
                  label={"Parent Container"}
                />
              </>
            )}
            <ToggleInput
              isResetVisible={false}
              value={sticky?.disableDesktop}
              onChange={(val) => {
                setProp((props) => {
                  props.sticky = {
                    ...(props.sticky ? props.sticky : {}),
                    disableDesktop: val,
                  };
                });
              }}
              label={"Disable on Desktop"}
            />
            <ToggleInput
              isResetVisible={false}
              value={sticky?.disableTablet}
              onChange={(val) => {
                setProp((props) => {
                  props.sticky = {
                    ...(props.sticky ? props.sticky : {}),
                    disableTablet: val,
                  };
                });
              }}
              label={"Disable on Tablet"}
            />
            <ToggleInput
              isResetVisible={false}
              value={sticky?.disableMobile}
              onChange={(val) => {
                setProp((props) => {
                  props.sticky = {
                    ...(props.sticky ? props.sticky : {}),
                    disableMobile: val,
                  };
                });
              }}
              label={"Disable on Mobile"}
            />
          </>
        )}
      </Panel>
    </>
  );
}

function transformProps(props, supportProps) {
  if (props.sticky && props.sticky.mode && props.sticky.mode !== "none") {
    var attr = { ...props.sticky };

    if (!props.sticky.keepInsideParent) {
      delete attr.keepInsideParent;
    }

    if (!props.sticky.insideParent) {
      delete attr.insideParent;
    }
    if (!props.sticky.disableDesktop) {
      delete attr.disableDesktop;
    }
    if (!props.sticky.disableTablet) {
      delete attr.disableTablet;
    }
    if (!props.sticky.disableMobile) {
      delete attr.disableMobile;
    }

    supportProps = {
      ...supportProps,
      className: {
        ...(supportProps.className ? supportProps.className : {}),
        "grigora-sticky": true,
      },
      "data-sticky_data": JSON.stringify({
        ...attr,
      }),
    };
  }
  return supportProps;
}

const supportSchema = {
  id: "grigora/sticky",
  name: "Sticky",
  component: Sticky,
  transformProps: transformProps,
};

export default supportSchema;
